import clsx from "clsx"
import React from "react"
import { useSelector } from "react-redux"
import {
  Grid,
  Typography,
  makeStyles,
} from "@material-ui/core"
import { LocalizedStrict } from "shared/Modules/Localization/Components/Localized"
import { selectUserIsPrivate } from "shared/Modules/User/userSelectors"
import { ChooseLocation } from "../Components/ChooseLocation"
import DrawerWithSpacing from "shared/Components/Dialog/DrawerWithSpacing"

const useStyles = makeStyles((theme) => ({
    container: {
        height: "100vh",
        padding: theme.spacing(3, 0),
    },
    indented: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
    },
    header: {
        alignSelf: "center",
        paddingBottom: theme.spacing(4),
    },
    scrollShadows: {
        overflow: "auto",
        background: `
          /* Shadow Cover TOP */
          linear-gradient(
            white 30%,
            rgba(255, 255, 255, 0)
          ) center top,

          /* Shadow Cover BOTTOM */
          linear-gradient(
            rgba(255, 255, 255, 0),
            white 70%
          ) center bottom,

          /* Shadow TOP */
          radial-gradient(
            farthest-side at 50% 0,
            rgba(0, 0, 0, 0.2),
            rgba(0, 0, 0, 0)
          ) center top,

          /* Shadow BOTTOM */
          radial-gradient(
            farthest-side at 50% 100%,
            rgba(0, 0, 0, 0.2),
            rgba(0, 0, 0, 0)
          ) center bottom;
        `,
        backgroundRepeat: "no-repeat",
        backgroundSize: "100% 40px, 100% 40px, 100% 14px, 100% 14px",
        backgroundAttachment: "local, local, scroll, scroll",
    }
}));

type ChooseFirstLocationProps = Readonly<{
    loadLocations: boolean
    onLocationChosen: () => void
}>

function ChooseFirstLocation({ loadLocations, onLocationChosen }: ChooseFirstLocationProps) {
    const classes = useStyles()

    const isPrivateUser = useSelector(selectUserIsPrivate)

    return (
        <Grid container direction="column" wrap="nowrap" justifyContent="space-between" className={clsx(classes.container, classes.scrollShadows)}>
            <Grid item container direction="column" wrap="nowrap">
                <Grid item>
                    <ChooseLocation loadLocations={loadLocations} onSelect={onLocationChosen} />
                </Grid>
            </Grid>

            {!isPrivateUser && (
                <Grid item className={classes.indented}>
                    <LocalizedStrict id="choose-location-help-text">
                        <Typography variant="subtitle2">
                            Findes din lokation ikke skal du kontakte jeres administrator.
                        </Typography>
                    </LocalizedStrict>
                </Grid>
            )}
        </Grid>
    )
}

interface ChooseFirstLocationModalProps {
    open: boolean
    onClose: () => void
    userHasNoLocation: boolean
}

export default function ChooseFirstLocationModal({ open, onClose, userHasNoLocation }: ChooseFirstLocationModalProps) {
    const isPrivateUser = useSelector(selectUserIsPrivate)

    return (
        <LocalizedStrict
            id={isPrivateUser ? "choose-location-header-private-user" : "choose-location-header-company-user"}
            attrs={{ title: true, children: false }}
        >
            <DrawerWithSpacing
                open={open}
                onClose={onClose}
                title="Vælg salgssted"
            >
                <ChooseFirstLocation
                    loadLocations={userHasNoLocation}
                    onLocationChosen={onClose}
                />
            </DrawerWithSpacing>
        </LocalizedStrict>
    )
}
